// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"U3-z"};